import React, { Component } from 'react';

import PanelRadioList from 'components/panelRadioList/PanelRadioList';
import Currency from 'helpers/Currency';
import { inject, observer } from 'mobx-react';
import SalesService from 'modules/salesManager/SalesService';
import PropTypes from 'prop-types';

import { I18n } from '../../../components/translate';

@inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))
@observer
class OfferPanelRadioList extends Component {
  static propTypes = {
    labelValue: PropTypes.string,
    panelLabel: PropTypes.string,
    items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    isMobile: PropTypes.bool,
    allowUncheck: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.string
    ]),
    selectedOffers: PropTypes.array,
    onUncheckItem: PropTypes.func,
    onCheckItem: PropTypes.func,
    forwardedRef: PropTypes.object
  };

  get isSubscription() {
    const { items } = this.props;

    return items && !Array.isArray(items);
  }

  get offersHeading() {
    const { items, isMobile } = this.props;
    const subheader = [];

    if (!isMobile) {
      subheader.push(SalesService.getSubHeader(items));
    }

    return subheader;
  }

  get items() {
    const { items } = this.props;

    return this.isSubscription ? items : this.offersHeading.concat(items);
  }

  formatItemMobile = (item) => {
    return (
      <div className="radio__custom__label">
        <div>
          {item.activationCode ? (
            item.activationCode
          ) : (
            <I18n label="general.default" />
          )}
          <br />
          <span className="secondary">{item.key}</span>
        </div>
        <div>
          {item.price && item.currencyCode && (
            <div className="secondary">
              <I18n label="general.price" />
              {`: ${Currency.formatCurrencySymbol(
                parseFloat(item.price),
                item.currencyCode
              )}`}
            </div>
          )}
        </div>
        {item.class && (
          <div className="secondary">
            <I18n label="general.class" />
            <span>{`: ${item.class}`}</span>
          </div>
        )}
      </div>
    );
  };

  formatItemDesktop = (item) => {
    return (
      <div className="radio__custom__label">
        <span>
          {item.activationCode ? (
            item.activationCode
          ) : (
            <I18n label="general.default" />
          )}
          <br />
          <span className="secondary">{item.key}</span>
        </span>
        <span>
          {item.price &&
            item.currencyCode &&
            Currency.formatCurrencySymbol(
              parseFloat(item.price),
              item.currencyCode
            )}
        </span>
        {item.class && <span>{item.class}</span>}
      </div>
    );
  };

  onRadiolistChange = (event) => {
    const { value: key, name } = event.target;
    const { selectedOffers, onUncheckItem, onCheckItem, allowUncheck } =
      this.props;

    const selected = selectedOffers.find((item) => item.offerKey === key);

    if (selected && allowUncheck) {
      onUncheckItem(selected);
    } else {
      onCheckItem({ offerKey: key, name }, name);
    }
  };

  render() {
    const {
      labelValue,
      panelLabel,
      allowUncheck,
      selectedOffers,
      isMobile,
      forwardedRef,
      ...props
    } = this.props;

    return (
      <div ref={forwardedRef}>
        <PanelRadioList
          {...props}
          onChange={this.onRadiolistChange.bind(this)}
          labelValue={labelValue}
          panelLabel={panelLabel}
          items={this.items}
          allowUncheck={allowUncheck}
          selectedOptions={selectedOffers}
          formatItem={isMobile ? this.formatItemMobile : this.formatItemDesktop}
        ></PanelRadioList>
      </div>
    );
  }
}

export default OfferPanelRadioList;
